export default __webpack_public_path__ + "static/media/reddit-place-bot-image.d3d84981.png";